import React, { useState } from "react";
import { Dropdown } from "antd";
import { TbDotsVertical } from "react-icons/tb";
import "./ReusableDropdownComp.css";
import MainButtonComp from "../Buttons/MainButtonComp";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../design-system/useMediaQuery";
import ActionSheet from "../../design-system/ActionSheet";

/**
 * Row "more actions" menu. Desktop: a dropdown. Phones: a bottom action sheet with thumb-sized
 * rows. Items render the same components in both, so their dialogs keep working.
 */
const DropdownComp = ({ menuItems, onSelectObject }) => {
  const router = useHistory();
  const { t } = useTranslation("dashboard");
  const isMobile = useIsMobile();
  const [sheetOpen, setSheetOpen] = useState(false);

  const handleSelectOption = item => {
    item?.link?.includes("http") ? window.location.replace(item?.link) : router.push(item?.link);
    item?.milestone && onSelectObject();
  };

  const renderItem = item =>
    item?.key === "view" ? (
      <MainButtonComp text="View" viewBtn onClick={() => handleSelectOption(item)} />
    ) : (
      item.component()
    );

  const trigger = (
    // A real button: 40px touch target, keyboard reachable, announced to screen readers.
    <button
      type="button"
      className="row-actions-trigger"
      aria-label={t("Actions")}
      aria-haspopup="menu"
      onClick={
        isMobile
          ? e => {
              e.stopPropagation();
              setSheetOpen(true);
            }
          : undefined
      }
    >
      <TbDotsVertical aria-hidden="true" />
    </button>
  );

  if (isMobile) {
    return (
      <>
        {trigger}
        <ActionSheet open={sheetOpen} onClose={() => setSheetOpen(false)} title={t("Actions")}>
          {menuItems.map((item, index) => (
            <React.Fragment key={index}>{renderItem(item)}</React.Fragment>
          ))}
        </ActionSheet>
      </>
    );
  }

  return (
    <Dropdown
      onClick={e => e.stopPropagation()}
      className="ReusableDropdownComp"
      menu={{
        items: menuItems.map((item, index) => ({
          key: index,
          className: "dropdown-menu-padding",
          label: renderItem(item)
        }))
      }}
      trigger={["click"]}
      placement="bottomRight"
    >
      {trigger}
    </Dropdown>
  );
};

export default DropdownComp;
